export default "__VITE_ASSET__Cca6m6pi__"